import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import styles from './pill.module.scss';

type PillVariant = 'primary' | 'secondary';

export interface PillProps {
  /** The class name to apply */
  className?: string;
  /** The number to display */
  count?: number;
  /** The icon to display */
  icon?: IconName;
  /** The limit to which the number is display */
  limit?: number;
  /** The variant style to use for the pill */
  variant?: PillVariant;
}

const variants: Record<PillVariant, string> = {
  primary: styles.isPrimary,
  secondary: styles.isSecondary,
};

const Pill = ({
  className,
  count,
  icon,
  limit = 99,
  variant = 'primary',
}: PillProps) => {
  const displayText =
    count !== undefined
      ? count > limit
        ? `+${limit}`
        : count.toString()
      : 'N/A';

  if (count === undefined) return null;

  return (
    <div className={classNames(styles.component, className, variants[variant])}>
      {icon ? (
        <Icon className={styles.icon} name={icon} size={12} />
      ) : (
        <Typography className={styles.text} tag="span" tagStyle="bodySmall">
          {displayText}
        </Typography>
      )}
    </div>
  );
};

Pill.displayName = 'Pill';

export default Pill;
